import { gql } from '@apollo/client';

export const SAVE_TAX_RATE = gql`
  mutation saveTaxRate($input: SaveTaxRateInput!) {
    saveTaxRate(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_TAX_RATE = gql`
  mutation deleteTaxRate($id: Int!) {
    deleteTaxRate(id: $id) {
      commandId
      correlationId
    }
  }
`;
